module.exports = __webpack_public_path__ + "img/tag_nav.96f03262.png";